import { createSelector } from '@app/utils/createSelector'

import { profileUserSelector } from '@app/store/slices/profile'

export const paymentMethodsSelector = createSelector([profileUserSelector], user => {
  if (!user) return null
  if (user.account_type !== 'parent') return null
  return user.payment_methods
})

export const paymentMethodSelector = createSelector([paymentMethodsSelector], methods => methods?.current ?? null)
